import angular from 'angular';
import * as R from 'ramda';

export default function ImpactAnalysisController(
  $filter,
  $q,
  $timeout,
  approveImpactAnalysisDialog,
  bcpDataService,
  loaderService,
  performBusinessImpactAnalysisDialog,
  prioritizeImpactAnalysisDialog,
  bulkSubmitImpactAnalysisDialog,
  bulkApproveImpactAnalysisDialog,
  resetImpactAnalysisDialog,
  ssDialogService
) {
  const vm = this;

  vm.canExpand = vm.status !== 'Impact Analysis Not Started';
  vm.isExpanded = false;

  vm.hasData = false;

  vm.canPerform = vm.canSubmitImpactAnalysis === 'true';
  vm.canApprove = vm.canApproveImpactAnalysis === 'true';
  vm.canPrioritize = vm.canPrioritizeImpactAnalysis === 'true';
  vm.canReset = (vm.canResetImpactAnalysis === 'true') && (vm.canResetProcesses === 'true');

  vm.handleExpandImpactAnalysis = _handleExpandImpactAnalysis;

  vm.handlePerformImpactAnalysis = _handlePerformImpactAnalysis;
  vm.handleBulkSubmitImpactAnalysis = _handleBulkSubmitImpactAnalysis;
  vm.handleApproveImpactAnalysis = _handleApproveImpactAnalysis;
  vm.handleBulkApproveImpactAnalysis = _handleBulkApproveImpactAnalysis;
  vm.handlePrioritizeImpactAnalysis = _handlePrioritizeImpactAnalysis;
  vm.handleResetImpactAnalysis = _handleResetImpactAnalysis;
  vm.orderProcess = _orderProcess;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    _initEventListeners();
  }

  function _initEventListeners() {
  }

  function _handleExpandImpactAnalysis() {
    if (vm.canExpand) {
      if (!vm.hasData) {
        loaderService.showViewLoader = true;
        bcpDataService.getProcessesByAssessment(vm.assessmentId).then((response) => {
          vm.processes = response.data.result;
          _classifyProcesses();
          $timeout(() => {
            vm.hasData = true;
            vm.isExpanded = true;
            loaderService.showViewLoader = false;
          }, 0);
        });
      } else {
        vm.isExpanded = !vm.isExpanded;
      }
    }
  }

  function _classifyProcesses() {
    vm.notStartedProcessCount = 0;
    vm.awaitingApprovalProcessCount = 0;
    vm.awaitingPrioritizationProcessCount = 0;
    vm.completedProcessCount = 0;

    angular.forEach(vm.processes, (process) => {
      if (R.isNil(process.impactAnalysis)) {
        vm.notStartedProcessCount += 1;
      } else if (process.impactAnalysis.submitted && process.impactAnalysis.approved
        && process.impactAnalysis.prioritized) {
        vm.completedProcessCount += 1;
      } else if (process.impactAnalysis.submitted && process.impactAnalysis.approved) {
        vm.awaitingPrioritizationProcessCount += 1;
      } else if (process.impactAnalysis.submitted) {
        vm.awaitingApprovalProcessCount += 1;
      } else {
        vm.notStartedProcessCount += 1;
      }
    });

    vm.canResetProcesses = ((vm.notStartedProcessCount + vm.awaitingApprovalProcessCount
      + vm.awaitingPrioritizationProcessCount) > 0);
  }

  function _handlePerformImpactAnalysis($event) {
    loaderService.showViewLoader = true;
    bcpDataService.getProcessesByUser(vm.assessmentId).then((response) => {
      const nonSubmittedProcesses = [];
      angular.forEach(response.data.result, (process) => {
        if (!process.isManaged
          && (!process.impactAnalysis || (process.impactAnalysis && !process.impactAnalysis.submitted))) {
          nonSubmittedProcesses.push(process);
        }
      });

      ssDialogService.dialogs.bcp.performBusinessImpactAnalysisDialog = ssDialogService.alert(
        performBusinessImpactAnalysisDialog.getOptions($event, {
          assessmentId: vm.assessmentId,
          processes: nonSubmittedProcesses,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.bcp.performBusinessImpactAnalysisDialog);
    });
  }

  function _handleBulkSubmitImpactAnalysis($event) {
    loaderService.showViewLoader = true;
    bcpDataService.getProcessesByUser(vm.assessmentId).then((response) => {

      const _processes = [];
      angular.forEach(response.data.result, (process) => {
        if ((process.maximumAcceptableDowntime > 0) && (process.recoveryTimeObjective > 0)) {
          _processes.push(process);
        }
      });

      ssDialogService.dialogs.bcp.bulkSubmitImpactAnalysisDialog = ssDialogService.alert(
        bulkSubmitImpactAnalysisDialog.getOptions($event, {
          processes: _processes,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.bcp.bulkSubmitImpactAnalysisDialog);
    });
  }

  function _handleApproveImpactAnalysis($event) {
    loaderService.showViewLoader = true;
    bcpDataService.getProcessesByUser(vm.assessmentId).then((response) => {
      ssDialogService.dialogs.bcp.approveImpactAnalysisDialog = ssDialogService.alert(
        approveImpactAnalysisDialog.getOptions($event, {
          processes: response.data.result,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.bcp.approveImpactAnalysisDialog);
    });
  }

  function _handleBulkApproveImpactAnalysis($event) {
    loaderService.showViewLoader = true;
    bcpDataService.getProcessesByUser(vm.assessmentId).then((response) => {
      ssDialogService.dialogs.bcp.bulkApproveImpactAnalysisDialog = ssDialogService.alert(
        bulkApproveImpactAnalysisDialog.getOptions($event, {
          processes: response.data.result,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.bcp.bulkApproveImpactAnalysisDialog);
    });
  }

  function _handlePrioritizeImpactAnalysis($event) {
    loaderService.showViewLoader = true;
    bcpDataService.getProcessesToPrioritize(vm.assessmentId).then((response) => {
      ssDialogService.dialogs.bcp.prioritizeImpactAnalysisDialog = ssDialogService.alert(
        prioritizeImpactAnalysisDialog.getOptions($event, {
          processes: response.data.result,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.bcp.prioritizeImpactAnalysisDialog);
    });
  }

  function _handleResetImpactAnalysis($event) {
    loaderService.showViewLoader = true;
    bcpDataService.getProcessesByAssessment(vm.assessmentId).then((response) => {
      loaderService.showViewLoader = false;
      const _processes = [];
      angular.forEach(response.data.result, (process) => {
        if (!process.isManaged) {
          _processes.push(process);
        }
      });
      ssDialogService.dialogs.bcp.resetImpactAnalysisDialog = ssDialogService.alert(
        resetImpactAnalysisDialog.getOptions($event, {
          processes: _processes,
          assessmentId: vm.assessmentId,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.bcp.resetImpactAnalysisDialog);
    });
  }

  function _orderProcess(process) {
    if (process.isManaged) {
      return -1; // skip this sort and place at top
    }
    return process;// return the default sort
  }
}

ImpactAnalysisController.$inject = [
  '$filter',
  '$q',
  '$timeout',
  'approveImpactAnalysisDialog',
  'bcpDataService',
  'loaderService',
  'performBusinessImpactAnalysisDialog',
  'prioritizeImpactAnalysisDialog',
  'bulkSubmitImpactAnalysisDialog',
  'bulkApproveImpactAnalysisDialog',
  'resetImpactAnalysisDialog',
  'ssDialogService'
];
